const ROW_ONE = [
  "Social media post",
  "Follow-up email",
  "Interview prep",
  "Birthday message",
  "Business proposal",
  "Sales copy",
  "YouTube script",
  "Comedy set",
  "Newsletter",
  "Keynote opener",
  "Wedding toast",
  "Cover letter",
  "Cold email",
  "60-sec pitch",
  "Performance review",
  "Meeting recap",
  "Team announcement",
  "Board update",
  "Song lyrics",
  "TikTok script",
  "Short story",
  "Anniversary message",
  "Holiday card",
  "Moving announcement",
  "Resume Bullet Improver",
  "Salary Negotiation",
  "LinkedIn Profile Optimizer",
  "Marketplace Listing",
  "Interview Answer",
  "Negotiation Reply",
  "Text Message Fixer",
];

const ROW_TWO = [
  "Awkward text",
  "Event invitation",
  "Negotiation script",
  "Investor update",
  "Brainstorm",
  "Stand-up comedy set",
  "Dating profile",
  "Resignation letter",
  "Product launch",
  "Thank-you note",
  "Personal essay",
  "LinkedIn post",
  "Twitter thread",
  "Podcast intro",
  "Slack message",
  "Promotion ask",
  "Recommendation letter",
  "Apology email",
  "Poem",
  "Vlog script",
  "Monologue",
  "Farewell speech",
  "Condolence note",
  "Baby shower toast",
  "Apology text",
  "Tone Guard",
  "Voice Strength",
  "Storytelling Mode",
  "Make This Better",
  "Routine Optimizer",
  "Vent → Message",
];

const ROW_THREE = [
  "Condolence message",
  "Graduation speech",
  "Retirement speech",
  "Farewell message",
  "Mother's Day message",
  "Father's Day message",
  "Pregnancy announcement",
  "New job announcement",
  "Breakup message",
  "Thank-you speech",
  "LinkedIn recommendation",
  "Executive summary",
  "Project proposal",
  "Grant proposal",
  "Weekly team update",
  "Constructive feedback",
  "Voicemail script",
  "Podcast episode description",
  "Opinion piece",
  "Hype post",
  "Yelp / Google review",
  "Airbnb guest review",
  "Brand story",
  "Email subject lines",
  "Scholarship essay",
  "Personal statement",
  "Press release",
  "Mission statement",
  "Book blurb",
  "Acceptance speech",
  "Hook Generator",
  "Difficult Conversation",
  "Hot Take Generator",
  "Personality Rewrite",
  "Humor Injector",
  "Specificity Enhancer",
  "Credibility Booster",
  "Overcomplication Reducer",
  "Boundary Setting",
  "Portfolio Case Study",
  "Promotion Justification",
];

function MarqueeRow({
  items,
  reverse = false,
  duration,
}: {
  items: string[];
  reverse?: boolean;
  duration?: string;
}) {
  const doubled = [...items, ...items];
  return (
    <div className="relative overflow-hidden">
      <div
        className={`flex gap-3 ${reverse ? "animate-marquee-reverse" : "animate-marquee"}`}
        style={{ width: "max-content", ...(duration ? { animationDuration: duration } : {}) }}
      >
        {doubled.map((item, i) => (
          <span
            key={i}
            className="shrink-0 px-5 py-2.5 rounded-full border border-cyan-500/30 bg-cyan-500/8 text-cyan-300 text-sm font-medium whitespace-nowrap
              shadow-[0_0_12px_hsl(188_90%_42%_/_0.15)] hover:border-cyan-400/60 hover:bg-cyan-500/15 hover:shadow-[0_0_20px_hsl(188_90%_42%_/_0.30)] transition-all duration-300 cursor-default"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function QuickstartCarousel() {
  return (
    <section className="py-24 px-4 sm:px-6 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-950/20 via-slate-900/30 to-transparent pointer-events-none" />
      <div className="max-w-5xl mx-auto relative">
        <div className="text-center mb-12">
          <p className="text-xs text-cyan-400 font-semibold uppercase tracking-widest mb-4">Start Here</p>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Everything you can make — with one click
          </h2>
          <p className="text-slate-300 text-lg max-w-xl mx-auto">
            Pick any starting point and ScribPost writes it in your voice. These are real one-click presets inside the product.
          </p>
        </div>

        <div className="relative rounded-2xl border border-cyan-500/20 bg-white/[0.03] overflow-hidden py-10 space-y-5 shadow-[0_0_60px_hsl(188_90%_42%_/_0.08)]">
          {/* Subtle inner glow */}
          <div className="absolute inset-0 bg-gradient-to-b from-cyan-500/5 via-transparent to-cyan-500/5 pointer-events-none" />
          {/* Left fade */}
          <div className="absolute left-0 top-0 bottom-0 w-20 z-10 bg-gradient-to-r from-[#0d1220] to-transparent pointer-events-none" />
          {/* Right fade */}
          <div className="absolute right-0 top-0 bottom-0 w-20 z-10 bg-gradient-to-l from-[#0d1220] to-transparent pointer-events-none" />

          <MarqueeRow items={ROW_ONE} reverse={false} duration="48s" />
          <MarqueeRow items={ROW_TWO} reverse={true} duration="58s" />
          <MarqueeRow items={ROW_THREE} reverse={false} duration="60s" />
        </div>
      </div>
    </section>
  );
}
